import {
  SELECTOR_OPTIONS_GET_REQUEST,
  SELECTOR_OPTIONS_GET_SUCCESS,
  SELECTOR_OPTIONS_GET_FAILURE,
} from '../../actions/constants/types';

function selectorReducer(state = {}, action) {
  switch (action.type) {
    case SELECTOR_OPTIONS_GET_REQUEST:
      return {
        ...state,
        [action.reduxIdentifier]: {
          isFetching: true,
          options: [],
        },
      };
    case SELECTOR_OPTIONS_GET_SUCCESS:
      return {
        ...state,
        [action.reduxIdentifier]: {
          isFetching: false,
          options: action.response.data.options,
        },
      };
    case SELECTOR_OPTIONS_GET_FAILURE:
      return {
        ...state,
        [action.reduxIdentifier]: {
          isFetching: false,
          options: [],
        },
      };
    default:
      return state;
  }
}

export default selectorReducer;
